import React, { useState } from 'react';
import Button from 'components/UI/V3/Button/Button';
import { EmailLocation } from '../../types';
import { LocationsChecklist } from '../LocationsChecklist/LocationsChecklist';
import styles from './LocationsScopePicker.module.scss';

interface LocationsScopePickerProps {
    locations: Array<EmailLocation>;
    selectedIds: Array<number>;
    onApply: (ids: Array<number>) => void;
}

// Staged selection: changes only take effect on "Apply" (same pattern as the main app filters).
export const LocationsScopePicker: React.FC<LocationsScopePickerProps> = ({ locations, selectedIds, onApply }) => {
    const [draftIds, setDraftIds] = useState<Array<number>>(selectedIds);

    return (
        <div className={styles.root}>
            <LocationsChecklist
                locations={locations}
                selectedIds={draftIds}
                listClassName={styles.list}
                onChange={setDraftIds}
            />
            <div className={styles.footer}>
                <Button
                    fullWidth
                    size="large"
                    variant="black"
                    label="Apply"
                    disabled={draftIds.length === 0}
                    onClick={() => onApply(draftIds)}
                />
            </div>
        </div>
    );
};

export default LocationsScopePicker;
